import script from "./TopScoringListSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopScoringListSelector.vue?vue&type=script&lang=ts&setup=true"

import "./TopScoringListSelector.vue?vue&type=style&index=0&id=ec9a4f0e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec9a4f0e"]])

export default __exports__